export const SET_FOOD_MENU = 'SET_FOOD_MENU';
export const UPDATE_FOOD_QUANTITY = 'UPDATE_FOOD_QUANTITY';
export const RESET_MENU = 'RESET_MENU';
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
